// extracted by mini-css-extract-plugin
module.exports = {"item":"_3bTT-nPGsU9f4lJnkmMr43"};